export default "__VITE_ASSET__CqV$KFpq__"